<!--
  숫자 입력 폼 컴포넌트

  @since 2018-02-06
  @author kdydesign.kim
-->

<template>
  <div :class="['bs-spinner-wrapper', classStr1]">
    <div :class="`${classStr2}${disable ? ' q-if-disabled' : ''}`"> <!-- input에 포커싱 될때 class="q-if-focused" 추가 -->
      <div class="q-if-inner col row no-wrap relative-position">
        <input ref="inputForm"
               class="col q-input-target q-no-input-spinner"
               v-model="inputVal"
               v-comma="thousandUnitComma"
               type="text"
               :min="minValue"
               :max="maxValue"
               :placeholder="placeholder"
               :maxlength="maxLength"
               :disabled="disable"
               :readonly="readonly"
               :suffix="suffix"
               :prefix="prefix"
               :align="align"
               @focus="onFocus"
               @blur="onBlur"
               @change="onChange"
               @keydown="onKeydownUpDown"
               style="display: inline-block; ime-mode:disabled;"/>
        <span class="spinner-prefix">{{ prefix }}</span>

        <tool-tip v-if="maxValue !== void 0 || minValue !== void 0 || defaultValue !== void 0"
                  :max-value="maxValue !== void 0 ? `${maxValue} ${maxToolTipSuffix}` : void 0"
                  :min-value="minValue !== void 0 ? `${minValue} ${minToolTipSuffix}` : void 0"
                  :default-value="defaultValue !== void 0 ? `${defaultValue} ${defaultToolTipSuffix}` : void 0"
                  :message="message"
        />

        <q-btn
               class="bs bs-spinner-btn bs-spinner-btn-up"
               :disabled="disable"
               :auth-force="authForce"
               enable-processing-click
               @click="setPlusValue">
        </q-btn>
        <q-btn
               class="bs bs-spinner-btn bs-spinner-btn-down"
               :disabled="disable"
               :auth-force="authForce"
               enable-processing-click
               @click="setMinusValue">
        </q-btn>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TouchSpin',
    props: {
      disable: {
        type: Boolean,
        default: false
      },
      readonly: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: ''
      },
      defaultValue: {
        type: [String, Number],
        default: void 0
      },
      mode: {
        type: [String],
        default: 'integer' // 'integer' or 'float' ( 소수 1자리 )
      },
      minValue: {
        type: [String, Number],
        default: void 0
      },
      maxValue: {
        type: [String, Number],
        default: void 0
      },
      step: {
        type: [String, Number],
        default: 1
      },
      value: {
        type: [String, Number],
        default: ''
      },
      suffix: {
        type: String,
        default: ''
      },
      prefix: {
        type: String,
        default: ''
      },
      align: {
        type: String,
        default: 'center'
      },
      blur: {
        type: Boolean,
        default: true
      },
      toolTipSuffix: {
        type: String,
        default: ''
      },
      minToolTipSuffix: {
        type: String,
        default: ''
      },
      maxToolTipSuffix: {
        type: String,
        default: ''
      },
      defaultToolTipSuffix: {
        type: String,
        default: ''
      },
      authForce: {
        type: Boolean,
        default: false
      },
      // TAMS
      message: {
        type: String,
        default: ''
      },
      thousandUnitComma: {
        type: Boolean,
        default: true
      },
      validExceptList: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      // TAMS 제외
      // authForceStr () {
      //   if (this.authForce) {
      //     return 'force'
      //   }
      //
      //   if (this.haForce && this.$store.state.common.common.backUp === true && this.$store.state.common.common.uiData.user.level !== 1) {
      //     return 'force'
      //   }
      //   return 'none'
      // }
    },
    data () {
      return {
        maxLength: void 0,
        inputVal: 0,
        iMax: 0,
        iMin: 0,
        iStep: 0,
        classStr1: '',
        classStr2: 'q-if row no-wrap items-end relative-position q-input bs bs-q-input bs-q-input-default text-primary '
      }
    },
    methods: {
      onKeydownUpDown (e) {
        if (e.shiftKey) {
          e.returnValue = false
          // IE / 파이어폭스 이벤트 차단
          e.preventDefault()
          return
        }
        let keyCode = e.keyCode

        // 알파벳 범위 (a ~ z)
        let isAlpha = keyCode > 64 && keyCode < 91

        // 특수기호 및 공백
        let isSpecWord = (keyCode > 105 && keyCode < 112) || (keyCode > 185 && keyCode < 193) || (keyCode > 218 && keyCode < 223) || keyCode === 32

        // float 모드인 경우 점 허용
        if (this.mode === 'float' && (keyCode === 110 || keyCode === 190)) {
          isSpecWord = false
        }

        if (keyCode === 38) {
          this.setPlusValue()
        } else if (keyCode === 40) {
          this.setMinusValue()
        }
        if (isAlpha || isSpecWord) { // 알파벳, 특수기호 및 공백 입력 불가
          e.returnValue = false
          // IE / 파이어폭스 이벤트 차단
          e.preventDefault()
        }
      },
      onUpdate () {
        if (this.mode === 'integer') {
          this.emitIntegerValue()
        } else if (this.mode === 'string') {
          this.emitStringValue()
        } else {
          this.emitFloatValue()
        }
        this.$refs.inputForm.value = this.inputVal
      },
      setPlusValue () {
        let iVal = Number(this.inputVal) + this.iStep
        if (isNaN(iVal) || iVal > this.iMax) {
          this.inputVal = this.iMax
        } else {
          this.inputVal = iVal
        }
        this.onUpdate()
        this.$emit('up', this.inputVal)
      },
      setMinusValue () {
        let iVal = Number(this.inputVal) - this.iStep

        if (isNaN(iVal) || iVal < this.iMin) {
          this.inputVal = this.iMin
        } else {
          this.inputVal = iVal
        }
        this.onUpdate()
        this.$emit('down', this.inputVal)
      },
      onFocus () {
        this.classStr2 = 'q-if row no-wrap items-end relative-position q-input bs bs-q-input bs-q-input-default text-primary q-if-focused'
      },
      onBlur () {
        this.classStr2 = 'q-if row no-wrap items-end relative-position q-input bs bs-q-input bs-q-input-default text-primary'
        this.checkValidNumber()
      },
      onChange () {
        if (this.blur) {
          const iVal = this.getOnlyNumber()
          // 입력값이 없는경우는 기본값 설정함
          if (this.defaultValue && this.inputVal === '') {
            this.inputVal = this.defaultValue
          } else {
            if (isNaN(iVal)) {
              this.inputVal = this.iMin
            } else if (iVal > this.iMax || iVal < this.iMin) {
              // 2022.06.27 > 유효성 검사 범위에서 제외해야 하는지 확인
              const findIdx = this.validExceptList.findIndex(value => value === iVal)

              // 유효성 검사 예외 목록에 없으면 min / max 체크 후 입력
              if (findIdx === -1) {
                this.inputVal = (iVal > this.iMax) ? this.iMax : this.iMin
              }
            }
          }
        }

        this.inputVal = !(this.mode === 'string' && this.inputVal === '') ? this.getOnlyNumber() : null
        this.$emit('change', this.inputVal)
      },
      /**
       * 이름: getOnlyNumber
       * 설명: 전달받은 파라미터 (없을 경우 inputVal) 문자열에서 숫자만 추출하여 정수형으로 리턴한다.
       */
      getOnlyNumber (targetVal = null) {
        return Number(String(targetVal || this.inputVal).replace(/[^0-9]/gi, ''))
      },
      emitFloatValue () {
        this.inputVal = parseFloat(this.inputVal).toFixed(1) - 0
        this.$emit('input', this.inputVal)
      },
      emitStringValue () {
        if (this.inputVal === '' || this.inputVal === void 0 || this.inputVal === null) {
          this.inputVal = null
        } else {
          if (_.isNaN(Number(this.inputVal))) {
            this.inputVal = void 0
          } else {
            let iVal = Number(this.inputVal)

            if (iVal > this.iMax || iVal < this.iMin) {
              // 2022.06.27 > 유효성 검사 범위에서 제외해야 하는지 확인
              const findIdx = this.validExceptList.findIndex(value => value === iVal)

              // 유효성 검사 예외 목록에 없으면 min / max 체크 후 입력
              if (findIdx === -1) {
                this.inputVal = (iVal > this.iMax) ? this.iMax : this.iMin
              }
            }
          }
        }

        this.$emit('input', this.inputVal)
      },
      emitIntegerValue () {
        this.inputVal = Number(this.inputVal)
        this.$emit('input', this.inputVal)
      },
      checkValidNumber () {
        if (this.blur) {
          let iVal = this.getOnlyNumber()

          if (isNaN(iVal)) {
            this.inputVal = this.iMin
          } else if (iVal > this.iMax || iVal < this.iMin) {
            // 2022.06.27 > 유효성 검사 범위에서 제외해야 하는지 확인
            const findIdx = this.validExceptList.findIndex(value => value === iVal)

            // 유효성 검사 예외 목록에 없으면 min / max 체크 후 입력
            if (findIdx === -1) {
              this.inputVal = (iVal > this.iMax) ? this.iMax : this.iMin
            }
          }
        }

        this.onUpdate()
      }
    },
    created () {
      if (this.mode === 'string') {
        this.inputVal = (this.value === '' || this.value === null || this.value === void 0) ? '' : this.value
      } else {
        this.inputVal = this.value
      }
    },
    mounted () {
      if (this.maxValue !== undefined) {
        const maxValLength = (this.maxValue + '').length

        this.maxLength = maxValLength + Math.floor(maxValLength / 4)
      }

      this.iMax = Number(this.maxValue)
      this.iMin = Number(this.minValue)
      this.iStep = Number(this.step)

      this.checkValidNumber()

      this.classStr1 = 'bs-spinner-wrapper '
      if (this.maxLength <= 3) {
        this.classStr1 += ' bs-q-if-3digit'
      } else if (this.maxLength <= 6) {
        this.classStr1 += ' bs-q-if-6digit'
      } else {
        this.classStr1 += 'bs-q-if-9digit'
      }

      if (this.mode === 'float') {
        this.iStep = 0.1
      }
    },
    beforeDestroy () {
      this.inputVal = ''
      this.$refs.inputForm.value = ''
    },
    watch: {
      value (v) {
        this.inputVal = v
        this.checkValidNumber()
      },
      maxValue () {
        this.iMax = Number(this.maxValue)
        if (this.maxValue !== undefined) {
          const maxValLength = (this.maxValue + '').length

          this.maxLength = maxValLength + Math.floor(maxValLength / 4)
        }
      },
      minValue () {
        this.iMin = Number(this.minValue)
      },
      step () {
        this.iStep = Number(this.step)
      }
    }
  }
</script>
